export default __webpack_public_path__ + "static/media/beginner.063195ce.svg";